(function () {
  'use strict';
  var loading;
  var pending = new WeakMap();
  var unavailable = 'Security check unavailable. Please check your connection and try again.';

  function load() {
    if (window.turnstile) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var script = document.querySelector('script[src^="https://challenges.cloudflare.com/turnstile/v0/api.js"]');
      var owned = !script;
      if (!script) {
        script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.async = true;
        script.dataset.pkTurnstile = 'true';
      }
      var timer = setTimeout(fail, 15000);
      function clean() { clearTimeout(timer); script.removeEventListener('load', done); script.removeEventListener('error', fail); }
      function done() { clean(); if (window.turnstile) resolve(); else fail(); }
      function fail() { clean(); if (owned) script.remove(); reject(new Error(unavailable)); }
      script.addEventListener('load', done, { once: true });
      script.addEventListener('error', fail, { once: true });
      if (owned) document.head.appendChild(script);
    }).catch(function (error) { loading = null; throw error; });
    return loading;
  }

  window.pkFormSecurity = {
    token: function (form, action) {
      if (pending.has(form)) return pending.get(form);
      var promise = (async function () {
        if (!window.pkFormSecuritySiteKey) throw new Error(unavailable);
        await load();
        return new Promise(function (resolve, reject) {
          var root = document.createElement('div');
          root.setAttribute('aria-label', 'Security check');
          root.style.gridColumn = '1 / -1';
          root.style.marginBlock = '12px';
          root.style.width = '100%';
          var button = form.querySelector('[type="submit"]');
          if (button) {
            var parent = button.parentElement;
            var layout = window.getComputedStyle(parent);
            if (parent !== form && layout.display === 'flex' && layout.flexDirection === 'row') parent.before(root);
            else button.before(root);
          } else form.appendChild(root);
          var id;
          var settled = false;
          var timer = setTimeout(function () { finish(new Error('Security check timed out. Please try again.')); }, 180000);
          function finish(error, token) {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            // Defer removal until Turnstile has finished dispatching its callback.
            setTimeout(function () { if (id !== undefined) window.turnstile.remove(id); root.remove(); }, 0);
            if (error) reject(error); else resolve(token);
          }
          try {
            id = window.turnstile.render(root, {
              sitekey: window.pkFormSecuritySiteKey,
              action: action,
              execution: 'execute',
              appearance: 'interaction-only',
              size: root.getBoundingClientRect().width < 300 ? 'compact' : 'flexible',
              'response-field': false,
              'before-interactive-callback': function () { root.scrollIntoView({ block: 'center', behavior: 'smooth' }); },
              callback: function (token) { finish(null, token); },
              'error-callback': function () { finish(new Error(unavailable)); },
              'expired-callback': function () { finish(new Error('Security check expired. Please try again.')); },
              'timeout-callback': function () { finish(new Error('Security check timed out. Please try again.')); }
            });
            window.turnstile.execute(id);
          } catch (_) { finish(new Error(unavailable)); }
        });
      })();
      pending.set(form, promise);
      promise.then(function () { pending.delete(form); }, function () { pending.delete(form); });
      return promise;
    }
  };
})();
